export default {
	themes: {
		light: 'Hell',
		dark: 'Dunkel'
	}
};
